// Canlı Durum kartının eklenti sürümü çipi. Sürüm = eklentinin manifest `version`'ı (Chrome: 1–4
// noktalı tam sayı, "2.2.1"). "Güncel değil" = kapsamdaki EN YENİ görülen sürümün altında — CWS
// yayınının kime henüz ulaşmadığını tek bakışta gösterir. Saf modül (test/ext-version.test.mjs).

/** Sayısal parça karşılaştırması; eksik parça 0 ("2.2" == "2.2.0"). Sayı olmayan parça 0 sayılır. */
export function cmpVersion(a: string, b: string): number {
  const pa = a.split('.');
  const pb = b.split('.');
  for (let i = 0; i < Math.max(pa.length, pb.length); i++) {
    const x = Number.parseInt(pa[i] ?? '0', 10) || 0;
    const y = Number.parseInt(pb[i] ?? '0', 10) || 0;
    if (x !== y) return x < y ? -1 : 1;
  }
  return 0;
}

/** Listedeki en yeni sürüm; boş dizgeler (görülmemiş) yok sayılır. Hiçbiri yoksa ''. */
export function newestVersion(versions: string[]): string {
  let best = '';
  for (const v of versions) if (v && (!best || cmpVersion(v, best) > 0)) best = v;
  return best;
}

/** Sürüm biliniyor VE en yeniden eski mi. Bilinmeyen sürüm "eski" DEĞİLDİR (§6: yokluk boş). */
export function isOutdated(version: string, newest: string): boolean {
  return !!version && !!newest && cmpVersion(version, newest) < 0;
}
